import { subjectGetDetails } from "common/_redux/subject/actions";
import { subjectSubjectsSelector } from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import Header from "layout/components/header";
import Topbar from "layout/components/topbar";
import VerificaIdentita from "pages/onBoarding/step-3/_common-components/verifica-identita";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import useReopenNavigate from "../hooks/reopenNavigate";

const title = "Identificazione Titolare Effettivo";
const subtitle = "Identificati.";

const ReopenIdentificazioneTE: React.FC = () => {
	const dispatch = useAppDispatch();

	const reopenNavigate = useReopenNavigate();

	const subjects = useAppSelector(subjectSubjectsSelector);

	const titolariSenzaAllegati =
		subjects?.elencoTitolariEffettivi?.filter(
			(titolare) => titolare.tipoSoggetto === "Titolare" && titolare?.elencoAllegati?.length === 0
		) || [];
	const [currentTitolareIndex, setCurrentTitolareIndex] = useState<number>(0);
	const currentTitolareEffettivo = titolariSenzaAllegati[currentTitolareIndex];

	const [isCompleted, setIsCompleted] = useState<boolean>(false);

	const navBack = () => {
		reopenNavigate?.goBack();
	};

	const goNext = () => {
		reopenNavigate?.goNext();
	};

	const handleUpload = (index: number) => {
		if (index === titolariSenzaAllegati.length - 1) {
			goNext();
		}
	};

	useEffect(() => {
		dispatch(subjectGetDetails());
	}, []);

	return (
		<>
			<div className="verifica-identita-page">
				<div className="d-flex flex-column min-vh-100">
					<div className="body flex-grow-1 px-0">
						<Header />
						<Topbar />

						<div className="container-fluid body-section px-0">
							<section>
								{titolariSenzaAllegati.length > 0 ? (
									<Row>
										<Col sm={12} lg={8}>
											<div>
												<h2 className="mb-3 ms-3">{title}</h2>
												<span className="gray">{subtitle}</span>
											</div>

											<BftAccordion
												key={currentTitolareIndex}
												title={`Verifica l'identità di ${currentTitolareEffettivo?.nome} ${
													currentTitolareEffettivo?.cognome
												} (${currentTitolareIndex + 1} di ${titolariSenzaAllegati.length})`}
												index={currentTitolareIndex + 1}
												total={titolariSenzaAllegati.length}
												isActive={!isCompleted}
												isCompleted={isCompleted}
											>
												<div>
													<VerificaIdentita
														subjectDetails={currentTitolareEffettivo}
														onComplete={() => handleUpload(currentTitolareIndex)}
														skipSaveStepStatus
													/>
												</div>
											</BftAccordion>

											<Row className="justify-content-between mx-1">
												<Col xs={1}>
													<BftButton
														className="btn-buffetti-secondary px-3"
														onClick={() => navBack()}
													>
														<i className="fas fa-arrow-left"></i>
													</BftButton>
												</Col>
											</Row>
										</Col>

										<Col sm={12} md={4} className="side-card">
											<DettaglioPianoCard />
										</Col>
									</Row>
								) : (
									<Row>
										<Col sm={12} lg={8}>
											<div>
												<h2 className="mb-3 ms-3">{title}</h2>
												<span className="gray mb-3">
													Non sono presenti documenti del titolare effettivo da caricare, procedi
													allo step successivo.
												</span>
											</div>

											<Row className="justify-content-between mx-1 mt-3">
												<Col xs={1}>
													<BftButton
														className="btn-buffetti-secondary px-3"
														onClick={() => navBack()}
													>
														<i className="fas fa-arrow-left"></i>
													</BftButton>
												</Col>

												<Col xs={10} md={11}>
													<BftButton className="btn-buffetti w-100" onClick={() => goNext()}>
														Vai allo step successivo
													</BftButton>
												</Col>
											</Row>
										</Col>

										<Col sm={12} md={4} className="side-card">
											<DettaglioPianoCard />
										</Col>
									</Row>
								)}
							</section>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ReopenIdentificazioneTE;
